import React, { useEffect, useState } from "react";
import {
  CheckCircle,
  ArrowLeft,
  Download,
  Send,
  Home,
  FileText,
  Calendar,
} from "lucide-react";
import "../CustomCSS/PaymentSuccess.css";
import Header2 from "../Sections/Header";
import { useLocation, useNavigate } from "react-router-dom";
import {
  APL_LINK,
  update_payment_for_user,
  server_post_data,
} from "../../ServiceConnection/serviceconnection";
import { computeTodayDate, handleError } from "../../CommonJquery/CommonJquery";

const SuccessCheckout = () => {
  const [animateIn, setAnimateIn] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showButtons, setShowButtons] = useState(false);
  const [ShowLoaderAdmin, setShowLoaderAdmin] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paymentId = queryParams.get("trun_id");
  const navigate = useNavigate();

  useEffect(() => {
    // Trigger animations after component mounts
    setTimeout(() => {
      setAnimateIn(true);
    }, 100);

    // Show buttons after the success animation
    setTimeout(() => {
      setShowButtons(true);
    }, 1000);
  }, []);

  const master_data_get = async () => {
    setShowLoaderAdmin(true);
    let fd = new FormData();
    fd.append("transaction_id", paymentId);
    fd.append("click_from", "1");
    await server_post_data(update_payment_for_user, fd)
      .then((Response) => {
        if (Response.error) {
          handleError(Response.message);
        } else {
          // Success handling
        }
        setShowLoaderAdmin(false);
      })
      .catch((error) => {
        handleError("network");
        setShowLoaderAdmin(false);
      });
  };

  useEffect(() => {
    master_data_get();

    const timer = setTimeout(() => {
      navigate("/my_bookings");
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Header2 />
      <div className="container-fluid py-4">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-5 mt-4">
            {/* Main Success Card */}
            <div className="card border-0 shadow-lg paymentsuccess-card">
              {/* Success Animation Container */}
              <div
                className="paymentsuccess-animation-container"
                style={{
                  padding: "1rem",
                }}
              >
                <div
                  className={`paymentsuccess-circle-outer ${
                    animateIn ? "animate" : ""
                  }`}
                  style={{
                    padding: "1rem 0",
                  }}
                >
                  <div
                    className={`paymentsuccess-circle-inner ${
                      animateIn ? "animate" : ""
                    }`}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <CheckCircle
                      size={40}
                      color="#70f46d"
                      className="paymentsuccess-check-icon"
                    />
                  </div>
                </div>
                <div
                  className={`paymentsuccess-success-text ${
                    animateIn ? "animate" : ""
                  }`}
                >
                  <h4 className="fw-bold text-center mb-0">
                    Payment Successful
                  </h4>
                  <p
                    className="text-center  mb-0 mt-2"
                    style={{ color: "green" }}
                  >
                    Your payment has been processed successfully
                  </p>
                </div>
                <p className="text-center mb-0 mt-2">
                  You will be automatically redirected to your bookings in a few
                  seconds.
                </p>
              </div>

              {/* Navigation Buttons */}
              {/* <div
                className={`card-footer bg-white border-0 p-4 paymentsuccess-actions ${
                  showButtons ? "show" : ""
                }`}
              >
                <div className="row g-3 align-items-center">
                  <div className="col-md-6">
                    <button
                      className="btn btn-outline-secondary w-100 d-flex align-items-center justify-content-center py-2 paymentsuccess-back"
                      onClick={() => navigate(-1)}
                    >
                      <ArrowLeft size={16} className="me-2" />
                      <span className="fw-medium">Back</span>
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button
                      className="btn btn-primary w-100 d-flex align-items-center justify-content-center py-2 paymentsuccess-go"
                      onClick={() => navigate("/")}
                    >
                      <Home size={16} className="me-2" />
                      <span className="fw-medium">Go to Home</span>
                    </button>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SuccessCheckout;
